import { render, staticRenderFns } from "./SkrillSuccess.vue?vue&type=template&id=ae720f10&"
import script from "./SkrillSuccess.vue?vue&type=script&lang=js&"
export * from "./SkrillSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports